import { OptionDto } from "@/dtos";
import currencyCodes from '@/helpers/jsons/currency-codes.json';

export const getCurrencyCodeOptions = () => {
    return currencyCodes.map(x => {
        const option: OptionDto = {
            label: x.name + ` (${x.code})`,
            value: x.code as any
        }
        return option;
    });
}


export const getCurrencyCodeOption = (code: string) => {
    const currencyCode = currencyCodes.find(x => x.code == code);
    if (currencyCode) {
        const option: OptionDto = {
            label: currencyCode.name + ` (${currencyCode.code})`,
            value: currencyCode.code as any
        }

        return option;
    }

    return {
        label: '',
        value: '' as any
    } as OptionDto;
}